import {
  Box,
  Paper,
  Avatar,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate } from "react-router-dom";
import { setUserEmail, setUserName, setSignInTime, setIsAdmin, setUserId } from "../utils/sessionCheck";
import { getSuperAdminEmails } from "../utils/superAdminEmails";
import { auth, provider, db } from "../firebase.config";
import { collection, query, where, getDocs } from "firebase/firestore";
import { signInWithPopup } from "firebase/auth";
import { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Navbar from "./Navbar";
import Footer from "./Footer";

const paperStyle = {
  padding: 40,
  height: "auto",
  width: 400,
  margin: "20px auto",
  borderRadius: "10px",
  boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
  backgroundColor: "#FFFFFF",
};

const avatarStyle = {
  bgcolor: "#1E2761",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
};

const buttonStyle = {
  bgcolor: "#1E2761",
  color: "#FFFFFF",
  width: "100%",
  marginTop: 20,
  '&:hover': {
    bgcolor: '#142a52',
    transform: 'scale(1.05)',
    transition: 'transform 0.2s',
  },
};

const SignIn = () => {
  const sitekey1 = process.env.REACT_APP_RECAPCTHA_SITE_KEY;
  const [isHumanReCaptcha, setIsHumanReCaptcha] = useState(false);
  const navigate = useNavigate();

 const superAdminEmails = getSuperAdminEmails();
  // const userEmail = currentUser.email.trim().toLowerCase();
  // const isSuperAdmin = superAdminEmails.includes(userEmail);
  

  function onReCaptchaChange(value) {
    if (value !== "NaN") {
      setIsHumanReCaptcha(true);
    }
  }

  const logGoogleUser = async () => {
    provider.setCustomParameters({ prompt: 'select_account' });

    try {
      const data = await signInWithPopup(auth, provider);

      const userEmail = data.user.email;
      setUserEmail(userEmail);
      setUserName(data.user.displayName);
      setSignInTime(new Date().toUTCString());

      const firebaseToken = await data.user.getIdToken();
      console.log("Firebase token:", firebaseToken);
      localStorage.setItem("token", firebaseToken);

      const querySnapshot = await getDocs(
        query(collection(db, "UserProfileMaster"), where("userEmail", "==", userEmail))
      );

      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0];
        setUserId(userDoc.id);
        await setIsAdmin(userDoc.data().userEmail);
        sessionStorage.setItem('tenantId', userDoc.data().tenantId);
        window.dispatchEvent(new Event("adminStatusChanged"));

        // Redirect based on super admin status
       // Redirect based on super admin status
        const userEmail = data.user.email.trim().toLowerCase();

        // Use window.location.assign() to force a full page refresh after sign-in.
        // This ensures all components and contexts reload with the new session data.
        if (superAdminEmails.includes(userEmail)) {
          window.location.assign("/TenantManagement"); // Hard refresh to Tenant Management
        } else {
          // We no longer need to pass state via navigate, as the HomePage
          // will read the fresh admin status from the session/context on reload.
          window.location.assign("/homepage"); // Hard refresh to Homepage
        }
      } 
      else {
        navigate("/signup", {
          state: {
            email: data.user.email,
            displayName: data.user.displayName,
          },
        });
      }
    } catch (error) {
      console.error("Sign in failed: ", error);
      alert("Sign in failed. Please try again.");
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar hideNavbar={false} />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
          background: 'linear-gradient(to bottom right, #1E2761, #1F1C2C)',
          backgroundAttachment: 'fixed',
        }}
      >
        <Paper elevation={10} style={paperStyle}>
          <Stack direction="column" spacing={2} alignItems="center">
            <Avatar sx={avatarStyle}>
              <LockIcon />
            </Avatar>
            <Typography variant="h4" color="#1E2761" textAlign="center" fontWeight="bold">
              Welcome!!
            </Typography>
            <Typography variant="body1" color="#555" textAlign="center" marginBottom={3}>
              Please sign in to continue to the Invoice & Quotation Generation App.
            </Typography>

            <ReCAPTCHA
              sitekey={sitekey1}
              onChange={onReCaptchaChange}
            />

            <Button
              type="button"
              variant="contained"
              fullWidth
              sx={buttonStyle}
              onClick={logGoogleUser}
            >
              Sign In With Google
            </Button>
          </Stack>
        </Paper>
      </Box>
      <Footer />
    </Box>
  );
};

export default SignIn;